export default __webpack_public_path__ + "static/media/07.fe22e532.jpg";